





































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { QDialog } from 'quasar'
import store from 'src/assets/store'

@Component
export default class Fullscreen extends Vue {
  viewport = store.viewport
  top = true

  @Prop({ type: Boolean, default: false })
  readonly noCancel!: boolean

  @Prop({ type: Boolean, default: false })
  readonly noTransition!: boolean

  @Ref()
  readonly dialog!: QDialog

  get height () {
    return this.viewport.height ? `${this.viewport.height}px` : '100%'
  }

  cancel () {
    this.hide()
    this.$emit('cancel')
  }

  show () {
    this.dialog.show()
    this.$nextTick(() => {
      this.dialog.focus()
    })
  }

  hide () {
    this.$emit('hide')
    this.dialog.hide()
  }

  escape (e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.hide()
    }
  }
}
